import { render, staticRenderFns } from "./boa-hora-how.vue?vue&type=template&id=78467e0e&scoped=true&"
import script from "./boa-hora-how.vue?vue&type=script&lang=ts&"
export * from "./boa-hora-how.vue?vue&type=script&lang=ts&"
import style0 from "./boa-hora-how.vue?vue&type=style&index=0&id=78467e0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78467e0e",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CFlex: require('@chakra-ui/vue').CFlex, CBox: require('@chakra-ui/vue').CBox})
